module.exports = __webpack_public_path__ + "static/media/top_shape_2_mob.b42d5254.svg";